window.site.renderRecaptchas = function() {
    if (typeof grecaptcha === 'undefined' || !grecaptcha.render) {
        return;
    }

    $('.g-recaptcha').each(function() {
        if ($(this).data('recaptchaWidgetId') === undefined) {
            var widgetId = grecaptcha.render(this, {
                sitekey: $(this).data('sitekey')
            });
            $(this).data('recaptchaWidgetId', widgetId);
        }
    });
}

// called by api.js once loaded (onload param)
window.siteOnRecaptchaLoad = function() {
    window.site.renderRecaptchas();
}

$(function(){
    // render any widgets present on initial page load (covers inline forms)
    window.site.renderRecaptchas();

    // forms injected into ajax popups need rendering once content is added
    $(document).on('popupOpen', function(){
        window.site.renderRecaptchas();
    });

    // an ajax submission consumes the captcha response - reset the widget
    // inside the submitted form so it can be retried
    $(document).on('ajax:request-complete ajaxComplete', '[data-request]', function(){
        $(this).find('.g-recaptcha').each(function(){
            var widgetId = $(this).data('recaptchaWidgetId');
            if (widgetId !== undefined && typeof grecaptcha !== 'undefined') {
                grecaptcha.reset(widgetId);
            }
        });
    });
});
